module.exports = __webpack_public_path__ + "media/images/solution1-28147ad0e21d28617c200b43fb1cd973.svg";